import React, { PureComponent } from 'react';
import Thumbnail from '../thumbnail';
import { getImgThumbUrl, getMediaId } from '../helpers';
import { trackEvent, trackTime } from '../../../utils/tracking.js';
import { subscribe, unsubscribe, publish } from '../../../utils/eventBus';
import './style.scss';
import PropTypes from 'prop-types';
import classNames from 'classnames';

class Player extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            isPlaying: false,
            showThumbnail: true,
            addAssetSource: false,
            isMuted: false,
            progress: '100 100',
            currentPlayer: null,
            remainingPlaytime: null
        };

        this.togglePlaying = this.togglePlaying.bind(this);
        this.play = this.play.bind(this);
        this.pause = this.pause.bind(this);
        this.pauseInternalPlayers = this.pauseInternalPlayers.bind(this);
        this.playerEnded = this.playerEnded.bind(this);
        this.updateVideoProgress = this.updateVideoProgress.bind(this);
        this.startTime = Date.now();
        this.getRemainingPlaytime = this.getRemainingPlaytime.bind(this);
    }

    componentDidMount() {
        subscribe('pauseAllPlayers', this.pause);
        subscribe('pauseInternalPlayers', this.pauseInternalPlayers);
        this.player.addEventListener('ended', this.playerEnded, false);
        this.player.addEventListener('timeupdate', this.updateVideoProgress, false);
        trackTime('player-component-did-mount', this.startTime, this.props.cardType);

    }

    componentWillUnmount() {
        unsubscribe('pauseAllPlayers', this.pause);
        unsubscribe('pauseInternalPlayers', this.pauseInternalPlayers);
        this.player.removeEventListener('ended', this.playerEnded, false);
        this.player.removeEventListener('timeupdate', this.updateVideoProgress, false);
        trackTime('player-component-did-unmount', this.startTime, this.props.cardType);
    }

    pauseInternalPlayers(payload) {
        if (payload.gigId === this.props.gigId) {
            this.pause();
        }
    }

    playerEnded() {
        this.setState({isPlaying: false});
    }

    updateVideoProgress() {
        const totalPercentage = 2 * 3.14 * 14,
            percentage = this.player.currentTime * totalPercentage / this.player.duration;

        this.setState({
            progress: `${percentage} 100`,
            remainingPlaytime: this.getRemainingPlaytime(this.player.currentTime, this.player.duration)
        });
    }

    play() {
        publish('pauseAllPlayers', {gigId: this.props.gigId});

        this.setState({
            showThumbnail: this.props.media.asset_type !== 'video',
            isPlaying: true,
            addAssetSource: true
        });
        this.player.play();
    }

    pause() {
        this.setState({isPlaying: false});
        this.player.pause();
    }

    togglePlaying(e) {
        e.preventDefault();

        if (this.player.paused) {
            this.play();
            trackEvent('player_play', this.props.cardType, this.props.cardSize);
        } else {
            this.pause();
            trackEvent('player_pause', this.props.cardType, this.props.cardSize);
        }
    }

    getRemainingPlaytime(currentTime, totalTime) {
        // Adding an extra second to prevent playback timer from showing "0:00"
        const remainingTime = totalTime - currentTime + 1,
            minutes = Math.floor(remainingTime / 60),
            seconds = Math.floor(remainingTime - (minutes * 60));

        return `${minutes}:${seconds < 10 ? `0${seconds}` : seconds}`;
    }

    render() {
        const { cardSize, media, shouldLoad}  = this.props,
            { showThumbnail, remainingPlaytime, progress, isPlaying, addAssetSource } = this.state,
            videoThumb = cardSize === 'large' ? media.video_thumb_lrg : media.video_thumb,
            mediaId = getMediaId(media.video_stream_url),
            showRemainingPlaytime = this.state.remainingPlaytime && media.asset_type === 'audio';

        const remainingTimeClasses = classNames('remaining-time', {'is-visible': this.state.isPlaying}),
            mediaPlayerClasses = classNames('media-player', cardSize, {'backdrop': !showThumbnail}),
            gigVideoButtonClasses = classNames('gig-video-button', {'pause': isPlaying, 'play': !isPlaying}, 'js-gig-video-button');

        return (
            <div className={mediaPlayerClasses}>
                {showThumbnail && <Thumbnail src={getImgThumbUrl(videoThumb)} shouldLoad={shouldLoad}/>}
                {showRemainingPlaytime && <span className={remainingTimeClasses}>{remainingPlaytime}</span>}
                <span className="gig-video-button-wrapper">
                    <span onClick={this.togglePlaying} className={gigVideoButtonClasses} data-aux-data="new-video-button-was-clicked" data-graphite='{"label": "gig_listing.video.click"}'></span>
                    <svg className="video-player-progress-wrapper js-video-player-progress-wrapper" viewBox="-2 -4 40 40">
                        <circle className="circle-progress-bar-background" r="14" cx="18" cy="14"/>
                        <circle style={{strokeDasharray: progress}} className="circle-progress-bar" r="14" cx="18" cy="14"/>
                    </svg>
                </span>
                {media.asset_type === 'video' &&
                    <video key={`player_${mediaId}`} id={`player_${mediaId}`} ref={(ref) => { this.player = ref; }}>
                        {addAssetSource && (
                            <source src={media.video_stream_url} type="video/mp4"/>
                        )}
                    </video>
                }

                {media.asset_type === 'audio' &&
                    <audio key={`player_${mediaId}`} id={`player_${mediaId}`} ref={(ref) => { this.player = ref; }}>
                        {addAssetSource && (
                            <source src={media.video_stream_url} type="audio/mp4"/>
                        )}
                    </audio>
                }
            </div>
        );
    }
}


Player.propTypes = {
    gigId: PropTypes.number,
    cardType: PropTypes.string
};

export default Player;



// WEBPACK FOOTER //
// ./src/shared/media/player/index.js